<template>
    <div class="group-basic-fields">
        <div class="corporate-dialog__row corporate-dialog__row--3">
            <v-text-field
                :model-value="modelValue.name"
                label="Nome do curso"
                placeholder="Digite o nome do curso"
                variant="outlined"
                density="compact"
                class="weeduc-admin-v-field"
                hide-details="auto"
                @update:model-value="patch({ name: $event })"
            />
            <v-text-field
                :model-value="modelValue.commercialName"
                label="Nome do comercial"
                placeholder="Digite o nome do comercial"
                variant="outlined"
                density="compact"
                class="weeduc-admin-v-field"
                hide-details="auto"
                @update:model-value="patch({ commercialName: $event })"
            />
            <v-text-field
                :model-value="modelValue.url"
                label="URL do curso"
                placeholder="Digite a URL do curso"
                variant="outlined"
                density="compact"
                class="weeduc-admin-v-field"
                hide-details="auto"
                @update:model-value="patch({ url: $event })"
            />
        </div>

        <div v-if="showPrice" class="group-basic-fields__price">
            <div class="group-basic-fields__toggle-row">
                <span>{{ $t('admin.groupBasicFields.setPrice') }}</span>
                <CustomToggle
                    id="group-price-toggle"
                    :model-value="!!modelValue.priceEnabled"
                    @update:model-value="onPriceEnabledChange"
                />
            </div>
            <div
                v-if="modelValue.priceEnabled"
                class="corporate-dialog__row corporate-dialog__row--4"
            >
                <v-text-field
                    :model-value="modelValue.price"
                    :label="$t('admin.groupBasicFields.optionalPrice')"
                    type="number"
                    min="0"
                    step="0.01"
                    prefix="R$"
                    placeholder="0,00"
                    variant="outlined"
                    density="compact"
                    class="weeduc-admin-v-field"
                    hide-details="auto"
                    @update:model-value="patch({ price: toNumber($event) })"
                />
                <v-text-field
                    :model-value="modelValue.discount"
                    label="Desconto (opcional)"
                    type="number"
                    min="0"
                    step="0.01"
                    prefix="R$"
                    placeholder="0,00"
                    variant="outlined"
                    density="compact"
                    class="weeduc-admin-v-field"
                    hide-details="auto"
                    @update:model-value="patch({ discount: toNumber($event) })"
                />
                <v-text-field
                    :model-value="finalPriceDisplay"
                    label="Valor Final"
                    prefix="R$"
                    variant="outlined"
                    density="compact"
                    class="weeduc-admin-v-field"
                    hide-details="auto"
                    readonly
                />
                <v-select
                    :model-value="modelValue.installment"
                    :items="installmentOptions"
                    :label="$t('admin.groupBasicFields.optionalInstallments')"
                    variant="outlined"
                    density="compact"
                    class="weeduc-admin-v-field"
                    hide-details="auto"
                    @update:model-value="patch({ installment: Number($event) || 1 })"
                />
            </div>
        </div>

        <div class="corporate-dialog__row">
            <v-textarea
                :model-value="modelValue.shortDescription"
                :label="$t('common.description')"
                :placeholder="$t('admin.courseForm.shortDescriptionPlaceholder')"
                variant="outlined"
                rows="3"
                class="weeduc-admin-v-field"
                hide-details="auto"
                @update:model-value="patch({ shortDescription: $event, description: $event })"
            />
            <v-textarea
                :model-value="modelValue.longDescription"
                :label="$t('admin.groupBasicFields.fullDescription')"
                :placeholder="$t('admin.courseForm.descriptionPlaceholder')"
                variant="outlined"
                rows="3"
                class="weeduc-admin-v-field"
                hide-details="auto"
                @update:model-value="patch({ longDescription: $event })"
            />
        </div>

        <div class="corporate-dialog__row corporate-dialog__row--3">
            <div class="group-basic-fields__toggle-block">
                <div class="group-basic-fields__toggle-row">
                    <span>{{ $t('admin.groupBasicFields.enableApproval') }}</span>
                    <CustomToggle
                        id="group-approval-toggle"
                        :model-value="modelValue.approvalEnabled"
                        @update:model-value="onApprovalChange"
                    />
                </div>
                <v-select
                    :model-value="modelValue.minGrade"
                    :items="gradeOptions"
                    :label="$t('admin.groupBasicFields.minGrade')"
                    variant="outlined"
                    density="compact"
                    class="weeduc-admin-v-field"
                    hide-details="auto"
                    :disabled="!modelValue.approvalEnabled"
                    @update:model-value="patch({ minGrade: Number($event) || 0 })"
                />
            </div>

            <div class="group-basic-fields__toggle-block">
                <div class="group-basic-fields__toggle-row">
                    <span>Possui certificado?</span>
                    <CustomToggle
                        id="group-certificate-toggle"
                        :model-value="modelValue.certificateEnabled"
                        @update:model-value="patch({ certificateEnabled: !!$event })"
                    />
                </div>
                <v-select
                    :model-value="modelValue.status"
                    :items="statusOptions"
                    item-title="text"
                    item-value="value"
                    label="Status"
                    variant="outlined"
                    density="compact"
                    class="weeduc-admin-v-field"
                    hide-details="auto"
                    @update:model-value="patch({ status: $event })"
                />
            </div>

            <div class="group-basic-fields__toggle-block">
                <div
                    class="group-basic-fields__toggle-row group-basic-fields__toggle-row--spacer"
                    aria-hidden="true"
                />
                <v-select
                    :model-value="modelValue.availabilityDeadline"
                    :items="availabilityOptions"
                    item-title="text"
                    item-value="value"
                    label="Prazo para Disponibilidade"
                    variant="outlined"
                    density="compact"
                    class="weeduc-admin-v-field"
                    hide-details="auto"
                    @update:model-value="patch({ availabilityDeadline: Number($event) })"
                />
            </div>
        </div>

        <div class="group-basic-fields__cover">
            <label class="group-basic-fields__cover-label">Capa do Produto - Principal</label>
            <CustomFileInput
                :model-value="coverPreview"
                height="160"
                :can-delete="true"
                info-text="Selecione uma imagem no formato JPG ou PNG"
                @update:model-value="onCoverChange"
            />
            <p class="group-basic-fields__helper">
                Tamanho recomendado: 1080x400 pixels
            </p>
        </div>
    </div>
</template>

<script>
import CustomToggle from '@/components/Form/CustomToggle.vue';
import CustomFileInput from '@/components/Form/CustomFileInput.vue';

export default {
    name: 'GroupBasicProductFields',
    components: { CustomToggle, CustomFileInput },
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        showPrice: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['update:modelValue'],
    computed: {
        coverPreview() {
            return this.modelValue.coverFile || this.modelValue.imageUrl || null;
        },
        finalPriceDisplay() {
            const value = Math.max(
                0,
                (Number(this.modelValue.price) || 0) - (Number(this.modelValue.discount) || 0),
            );
            return value.toFixed(2);
        },
        installmentOptions() {
            return Array.from({ length: 12 }, (_, i) => i + 1);
        },
        gradeOptions() {
            return [
                { title: '0', value: 0 },
                ...Array.from({ length: 20 }, (_, i) => {
                    const value = (i + 1) / 2;
                    return { title: String(value), value };
                }),
            ];
        },
        statusOptions() {
            return [
                { text: this.$t('common.active'), value: 'active' },
                { text: this.$t('admin.courseForm.statusInternalOnly'), value: 'internal' },
                { text: this.$t('common.inactive'), value: 'inactive' },
            ];
        },
        availabilityOptions() {
            return [
                { text: '1 dia', value: 1 },
                { text: '2 dias', value: 2 },
                { text: '3 dias', value: 3 },
                { text: '4 dias', value: 4 },
                { text: '5 dias', value: 5 },
                { text: '6 dias', value: 6 },
                { text: '7 dias', value: 7 },
                { text: '8 dias', value: 8 },
                { text: '9 dias', value: 9 },
                { text: '10 dias', value: 10 },
                { text: '20 dias', value: 20 },
                { text: '30 dias', value: 30 },
                { text: '40 dias', value: 40 },
                { text: '50 dias', value: 50 },
                { text: '60 dias', value: 60 },
                { text: '70 dias', value: 70 },
                { text: '80 dias', value: 80 },
                { text: '90 dias', value: 90 },
                { text: '4 meses', value: 120 },
                { text: '5 meses', value: 150 },
                { text: '6 meses', value: 180 },
                { text: '7 meses', value: 210 },
                { text: '8 meses', value: 240 },
                { text: '9 meses', value: 270 },
                { text: '10 meses', value: 300 },
                { text: '11 meses', value: 330 },
                { text: '12 meses', value: 365 },
                { text: this.$t('admin.groupBasicFields.lifelong'), value: 0 },
            ];
        },
    },
    methods: {
        toNumber(value) {
            if (value === '' || value == null) return 0;
            const n = Number(value);
            return Number.isFinite(n) ? n : 0;
        },
        formatUrl(value) {
            return String(value || '')
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/ç/g, 'c')
                .replace(/[^a-z0-9\s]/g, '')
                .replace(/\s+/g, '-')
                .trim();
        },
        patch(partial) {
            const next = { ...this.modelValue, ...partial };
            if (Object.prototype.hasOwnProperty.call(partial, 'name')) {
                const prevName = this.modelValue.name;
                const commercial = this.modelValue.commercialName;
                if (!commercial || commercial === prevName) {
                    next.commercialName = partial.name;
                }
                if (!this.modelValue.url || this.modelValue.url === this.formatUrl(prevName)) {
                    next.url = this.formatUrl(partial.name);
                }
            }
            this.$emit('update:modelValue', next);
        },
        onPriceEnabledChange(value) {
            if (value) {
                this.patch({ priceEnabled: true });
                return;
            }
            this.patch({
                priceEnabled: false,
                price: 0,
                discount: 0,
                installment: 1,
            });
        },
        onApprovalChange(value) {
            this.patch({
                approvalEnabled: !!value,
                minGrade: value ? this.modelValue.minGrade : 0,
            });
        },
        onCoverChange(value) {
            if (!value) {
                this.patch({ coverFile: null, imageUrl: '' });
                return;
            }
            if (value instanceof File) {
                this.patch({
                    coverFile: value,
                    imageUrl: URL.createObjectURL(value),
                });
                return;
            }
            this.patch({ coverFile: value, imageUrl: value });
        },
    },
};
</script>

<style scoped>
.group-basic-fields {
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
}

.corporate-dialog__row--3 {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem;
}

.corporate-dialog__row--4 {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 0.75rem;
}

.group-basic-fields__price {
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
}

.group-basic-fields__toggle-block {
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
}

.group-basic-fields__toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    min-height: 40px;
    font-size: 0.875rem;
    color: #3a3f4b;
}

.group-basic-fields__toggle-row--spacer {
    visibility: hidden;
    pointer-events: none;
}

.group-basic-fields__cover-label {
    display: block;
    margin-bottom: 0.45rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: #3a3f4b;
}

.group-basic-fields__helper {
    margin: 0.45rem 0 0;
    font-size: 0.8rem;
    color: #7a8190;
}

@media (max-width: 960px) {
    .corporate-dialog__row--3,
    .corporate-dialog__row--4 {
        grid-template-columns: 1fr;
    }
}
</style>
